import { createContext } from 'react'

type Props = {
    frame: number
    progress: number
}

export const ArtboardLoopContext = createContext({} as Props)
